import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { CostoSegmentoTipoCamionEdit } from "./modal";
const EditModal = CostoSegmentoTipoCamionEdit;

type Entity = models.CostoSegmentoTipoCamion;
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;

    idSegmento: number;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Tipo Camion", cell: x => ({ data: x.TipoCamion.Clave+" - "+x.TipoCamion.Descripcion }) },
        { title: "Costo", cell: x => ({ data: x.CostoFleteLogistica }) },
    ];
}

/**
* Listado de SucursalMunicipio
*/
class SegmentoCamionListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    private async setDescripciones(val: models.CostoSegmentoTipoCamion): Promise<models.CostoSegmentoTipoCamionDTO> {
        debugger
        const camion = await resources.CatalogosSAT.GetCpSatConfigAutotransporte(val.IdTipoCamion);
        const camionDescripcion = camion.Clave;
        val.TipoCamion = camion
        val.IdSegmento = this.props.idSegmento

        return { ...val, NombreCamion: camionDescripcion };
    }

    private handleOnAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await this.setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    private handleOnEditar = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await this.setDescripciones(result.value);;
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    private handleOnBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.TipoCamion.Clave);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        console.log(this);
        
        const cols = columnas({ onBorrar: this.handleOnBorrar, onEdit: this.handleOnEditar });
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            <span></span>
                            <div className="pull-right">
                                <kea.AgregarButton onClick={this.handleOnAgregar} disabled={this.props.readonly} />
                            </div>
                        </h4>
                    </div>
                </div>
                <h4>Costo de flete por tipo de camion</h4>
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const SegmentoCamionList = kea.mapProps(componentToRx(SegmentoCamionListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/segmentos/edit/list.tsx